var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FFC1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8321 10.4944L23.9443 9.38213C25.7872 7.53929 28.775 7.53929 30.6179 9.38213C32.4607 11.225 32.4607 14.2128 30.6179 16.0557L29.5056 17.1679M22.8321 10.4944C22.8321 10.4944 22.9711 12.8579 25.0566 14.9434C27.1421 17.0289 29.5056 17.1679 29.5056 17.1679M22.8321 10.4944L12.6066 20.7199C11.914 21.4125 11.5677 21.7588 11.2699 22.1406C10.9186 22.591 10.6174 23.0784 10.3716 23.594C10.1633 24.0312 10.0084 24.4958 9.69867 25.425L8.38617 29.3625M29.5056 17.1679L19.2801 27.3934C18.5875 28.086 18.2412 28.4323 17.8594 28.7301C17.409 29.0814 16.9216 29.3826 16.406 29.6284C15.9688 29.8367 15.5042 29.9916 14.575 30.3013L10.6375 31.6138M10.6375 31.6138L9.67501 31.9347C9.21774 32.0871 8.71359 31.9681 8.37276 31.6272C8.03193 31.2864 7.91291 30.7823 8.06534 30.325L8.38617 29.3625M10.6375 31.6138L8.38617 29.3625",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-pdf.986bdbfc5bb68cb048be0604ebd68601.svg";